import { useIonViewWillEnter } from '@ionic/react';
import { useHistory } from 'react-router-dom';
import { getAuthorizationState } from './hooks';

export function useRequireAuth() {
  const redirectUrl = '/logon';
  const history = useHistory();
  useIonViewWillEnter(() => {
    if (!getAuthorizationState()) {
      history.push(redirectUrl);
    }
  }, [history, redirectUrl]);
}
